import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
import Footer from "./modules/views/Footer";
import AppAppBar from "./modules/views/AppAppBar";
import "./JurisprudencePage.css";
import './modules/views/styles.scss';
import ScrollReveal from './modules/views/ScrollReveal';

import AlenaGoriachaia from "./photos/alona-main.jpg";
import MikhailoGoriachii from "./modules/views/Employees/photos/MikhailoGoriachii.jpg";
import nikolay from "./modules/views/Employees/photos/nikolay.jpg";
import natalia2 from "./modules/views/Employees/photos/natalia2.jpg";
import olena from "./modules/views/Employees/photos/olena.jpg";
import oksana from "./modules/views/Employees/photos/oksana.jpg";
import vadim from "./modules/views/Employees/photos/Vadim.jpg";
import annanovikova from "./modules/views/Employees/photos/annanovikova.jpg";

const contactEmployees = [
  { fullName: 'Горяча Альона Юріївна', position: 'Керівник', experience: 'Досвід 18 років', phone: '+380966341617', img: AlenaGoriachaia },
  { fullName: 'Субота Михайло Юрійович', position: 'Логіст', experience: 'Англійська, польська. 24/7', phone: '+380670001028', img: MikhailoGoriachii },
  { fullName: 'Шевченко Микола Григорович', position: 'Куратор логістичного відділу', experience: '', phone: '+380675589292', img: nikolay },
  { fullName: 'Хлівна Наталя Юріївна', position: 'Фахівець з транспортування', experience: 'Товари народного споживання', phone: '+380670001460', img: natalia2 },
  { fullName: 'Кириченко Олена Миколаївна', position: 'Керівник відділу експедитування', experience: 'Міжнародні напрямки, зернові', phone: '+380675047553', img: olena },
  { fullName: 'Сливка Вадим Ігорович', position: 'Логіст', experience: 'Великогабаритний транспорт', phone: '+380670110411', img: vadim },
  { fullName: 'Оксана Сергіївна', position: 'Помічник головного бухгалтера', experience: '', phone: '+380633974840', img: oksana },
  { fullName: 'Анна Новікова', position: 'Логіст', experience: 'Відповідальна людина', phone: '+380770310101', img: annanovikova },
];

const phonePretty = (phone) => {
  const g = phone.substr(0, 3);
  const c = phone.substr(3, 3);
  const p1 = phone.substr(6, 3);
  const p2 = phone.substr(9, 2);
  const p3 = phone.substr(11, 2);
  return `${g} (${c}) ${p1} ${p2} ${p3}`;
};

// Three.js floating particles background
function ParticlesBg() {
  const mountRef = useRef(null);

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) return;

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(60, mount.clientWidth / mount.clientHeight, 0.1, 1000);
    camera.position.z = 300;

    const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    renderer.setSize(mount.clientWidth, mount.clientHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setClearColor(0x000000, 0);
    mount.appendChild(renderer.domElement);

    // Particles
    const particleCount = 120;
    const geometry = new THREE.BufferGeometry();
    const positions = new Float32Array(particleCount * 3);
    const velocities = [];

    for (let i = 0; i < particleCount; i++) {
      positions[i * 3] = (Math.random() - 0.5) * 600;
      positions[i * 3 + 1] = (Math.random() - 0.5) * 600;
      positions[i * 3 + 2] = (Math.random() - 0.5) * 300;
      velocities.push({
        x: (Math.random() - 0.5) * 0.3,
        y: (Math.random() - 0.5) * 0.3,
        z: (Math.random() - 0.5) * 0.1,
      });
    }

    geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

    const material = new THREE.PointsMaterial({
      color: 0x16b724,
      size: 2.5,
      transparent: true,
      opacity: 0.6,
      blending: THREE.AdditiveBlending,
    });

    const points = new THREE.Points(geometry, material);
    scene.add(points);

    // Connection lines
    const lineMaterial = new THREE.LineBasicMaterial({
      color: 0x16b724,
      transparent: true,
      opacity: 0.08,
    });

    let linesMesh = null;

    const animate = () => {
      const posArr = geometry.attributes.position.array;

      for (let i = 0; i < particleCount; i++) {
        posArr[i * 3] += velocities[i].x;
        posArr[i * 3 + 1] += velocities[i].y;
        posArr[i * 3 + 2] += velocities[i].z;

        // Bounce
        if (Math.abs(posArr[i * 3]) > 300) velocities[i].x *= -1;
        if (Math.abs(posArr[i * 3 + 1]) > 300) velocities[i].y *= -1;
        if (Math.abs(posArr[i * 3 + 2]) > 150) velocities[i].z *= -1;
      }
      geometry.attributes.position.needsUpdate = true;

      // Draw connection lines
      if (linesMesh) scene.remove(linesMesh);
      const linePositions = [];
      for (let i = 0; i < particleCount; i++) {
        for (let j = i + 1; j < particleCount; j++) {
          const dx = posArr[i * 3] - posArr[j * 3];
          const dy = posArr[i * 3 + 1] - posArr[j * 3 + 1];
          const dz = posArr[i * 3 + 2] - posArr[j * 3 + 2];
          const dist = Math.sqrt(dx * dx + dy * dy + dz * dz);
          if (dist < 80) {
            linePositions.push(posArr[i * 3], posArr[i * 3 + 1], posArr[i * 3 + 2]);
            linePositions.push(posArr[j * 3], posArr[j * 3 + 1], posArr[j * 3 + 2]);
          }
        }
      }
      const lineGeom = new THREE.BufferGeometry();
      lineGeom.setAttribute('position', new THREE.Float32BufferAttribute(linePositions, 3));
      linesMesh = new THREE.LineSegments(lineGeom, lineMaterial);
      scene.add(linesMesh);

      points.rotation.y += 0.0003;
      renderer.render(scene, camera);
      requestAnimationFrame(animate);
    };

    animate();

    const handleResize = () => {
      if (!mount) return;
      camera.aspect = mount.clientWidth / mount.clientHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(mount.clientWidth, mount.clientHeight);
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (mount && renderer.domElement) {
        mount.removeChild(renderer.domElement);
      }
      renderer.dispose();
    };
  }, []);

  return (
    <div ref={mountRef} style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      zIndex: 0,
    }} />
  );
}

function Contacts() {
  return (
    <React.Fragment>
      <AppAppBar />

      {/* Hero + Cards combined section with Three.js background */}
      <section style={{
        position: 'relative',
        background: 'linear-gradient(180deg, #0a0a0f 0%, #060d08 50%, #0a0a0f 100%)',
        paddingTop: 120,
        paddingBottom: 80,
        minHeight: '100vh',
        overflow: 'hidden',
      }}>
        <ParticlesBg />

        {/* Content over particles */}
        <div style={{ position: 'relative', zIndex: 1 }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: 50, padding: '0 24px' }}>
            <h1 style={{
              fontSize: 'clamp(28px, 5vw, 48px)',
              fontWeight: 700,
              color: '#fff',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              marginBottom: 16,
            }}>
              Наші <span style={{
                background: 'linear-gradient(135deg, #16b724, #4dc247)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}>контакти</span>
            </h1>
            <p style={{
              color: 'rgba(255,255,255,0.5)',
              fontSize: 'clamp(14px, 2vw, 18px)',
              maxWidth: 500,
              margin: '0 auto',
            }}>
              Зв'яжіться з нашою командою, ми завжди на зв'язку
            </p>
          </div>

          {/* Cards grid */}
          <div className="contacts-grid" style={{
            maxWidth: 1200,
            margin: '0 auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: 24,
            padding: '0 24px',
          }}>
            {contactEmployees.map((emp, i) => (
              <ScrollReveal key={i} delay={i * 0.06}>
                <div className="contact-card" style={{
                  background: 'rgba(255,255,255,0.04)',
                  backdropFilter: 'blur(12px)',
                  WebkitBackdropFilter: 'blur(12px)',
                  border: '1px solid rgba(22,183,36,0.12)',
                  borderRadius: 20,
                  padding: '30px 28px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 20,
                  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                  cursor: 'default',
                  height: '100%',
                  boxSizing: 'border-box',
                  position: 'relative',
                }}
                onMouseOver={e => {
                  e.currentTarget.style.background = 'rgba(22,183,36,0.08)';
                  e.currentTarget.style.borderColor = 'rgba(22,183,36,0.35)';
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 40px rgba(22,183,36,0.15), inset 0 1px 0 rgba(255,255,255,0.05)';
                }}
                onMouseOut={e => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.04)';
                  e.currentTarget.style.borderColor = 'rgba(22,183,36,0.12)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
                >
                  {/* Glow accent */}
                  <div style={{
                    position: 'absolute',
                    top: -40,
                    right: -40,
                    width: 100,
                    height: 100,
                    background: 'radial-gradient(circle, rgba(22,183,36,0.08) 0%, transparent 70%)',
                    pointerEvents: 'none',
                  }} />

                  {/* Photo */}
                  <div style={{
                    width: 90,
                    height: 90,
                    borderRadius: '50%',
                    overflow: 'hidden',
                    flexShrink: 0,
                    border: '2px solid rgba(22,183,36,0.25)',
                    boxShadow: '0 0 20px rgba(22,183,36,0.1)',
                  }}>
                    <img src={emp.img} alt={emp.fullName} style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }} />
                  </div>

                  {/* Info */}
                  <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <h3 style={{
                      fontSize: 17,
                      fontWeight: 600,
                      color: '#fff',
                      margin: '0 0 4px',
                      lineHeight: 1.3,
                    }}>
                      {emp.fullName}
                    </h3>
                    <p style={{
                      fontSize: 14,
                      color: '#4dc247',
                      margin: '0 0 4px',
                      fontWeight: 500,
                      lineHeight: 1.3,
                    }}>
                      {emp.position}
                    </p>
                    {emp.experience && (
                      <p style={{
                        fontSize: 12,
                        color: 'rgba(255,255,255,0.4)',
                        margin: '0 0 12px',
                        lineHeight: 1.3,
                      }}>
                        {emp.experience}
                      </p>
                    )}
                    {!emp.experience && <div style={{ height: 12 }} />}

                    {/* Contact buttons */}
                    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', flexDirection: 'column' }}>
                      <a href={`tel:${emp.phone}`} style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6,
                        padding: '6px 14px',
                        background: 'linear-gradient(135deg, #16b724, #0e8a1a)',
                        color: '#fff',
                        fontSize: 12,
                        fontWeight: 600,
                        textDecoration: 'none',
                        borderRadius: 24,
                        whiteSpace: 'nowrap',
                        boxShadow: '0 2px 12px rgba(22,183,36,0.2)',
                        transition: 'all 0.3s ease',
                      }}>
                        {phonePretty(emp.phone)}
                      </a>
                      <a href={`viber://chat?number=%2B${emp.phone.replace('+', '')}`} style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '6px 14px',
                        background: 'rgba(22,183,36,0.06)',
                        color: '#4dc247',
                        fontSize: 12,
                        fontWeight: 600,
                        textDecoration: 'none',
                        borderRadius: 24,
                        border: '1px solid rgba(22,183,36,0.25)',
                        whiteSpace: 'nowrap',
                        transition: 'all 0.3s ease',
                      }}>
                        Viber
                      </a>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        @media (max-width: 1024px) {
          .contacts-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 640px) {
          .contacts-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </React.Fragment>
  );
}

export default Contacts;
